import { formatDate } from '../../helpers/date'
import { DateFormat } from '../../types/dateFormatTypes'
import { transformToPeriod } from '../Period/PeriodTransformers'
import {
    LeaveOfAbsence,
    LeaveOfAbsenceForm,
    LeaveOfAbsencePostRequest,
    LeaveOfAbsenceResource,
} from './LeaveOfAbsences'

export const transformLeaveOfAbsences = (resource: LeaveOfAbsenceResource): LeaveOfAbsence => ({
    id: resource.id,
    createdAt: new Date(resource.attributes.createdAt),
    status: resource.attributes.status,
    declineReason: resource.attributes.declineReason,
    reason: resource.attributes.reason || '',
    period: transformToPeriod(new Date(resource.attributes.start), new Date(resource.attributes.end)),
    changeset: {
        start: resource.attributes.changeset?.start ? new Date(resource.attributes.changeset.start) : undefined,
        end: resource.attributes.changeset?.end ? new Date(resource.attributes.changeset.end) : undefined,
        requestedAt: resource.attributes.changeset?.requestedAt ? new Date(resource.attributes.changeset?.requestedAt) : undefined,
    },
    hasPendingChangeset: resource.attributes.hasPendingChangeset,
})

export const transformLeaveOfAbsencesDetailToFormDataApiParams = (formData: LeaveOfAbsenceForm): LeaveOfAbsencePostRequest => ({
    type: 'leaveOfAbsences',
    attributes: {
        end: formatDate(formData.endDate, DateFormat.apiDateTime),
        start: formatDate(formData.startDate, DateFormat.apiDateTime),
        reason: formData.reason,
    },
})
